import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as mainActions from '../../actions/mainActions';
import { Grid, Card, Typography, LinearProgress, Button } from 'material-ui';
import AddIcon from '@material-ui/icons/Add';
import { requestSurveys } from '../../controllers/surveys';
import PaginatedTable from '../displayComponents/PaginatedTable';
import { toast } from 'react-toastify';
import moment from 'moment';
import DatePickerCustom from '../displayComponents/DatePickerCustom';
import SelectComponent from '../displayComponents/SelectComponent';
import Satisfation from './Satisfation';
import { validateDatesFilter } from '../SurveyResults/SurveyResultsContainer';

class Satisfations extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentLimit: 15,
            currentPage: 0,
            satisfactionSurveyList: [],
            rows: 0,
            downloading: true,
            loading: false,
            columns: [{
                name: 'municipality',
                title: 'Concello'
            }, {
                name: 'office',
                title: 'Oficina'
            },
            //   {
            //     name: 'name',
            //     title: 'Usuario'
            //   }, 
            {
                name: 'source',
                title: 'Orixe'
            }, {
                name: 'survey_date',
                title: 'Fecha e hora da enquisa'
            }],
            filter: {
                municipality: -1,
                office: -1,
                user: "-1",
                from: moment()
                .subtract(3, "month")
                .format("DD/MM/YYYY 00:00"),
                to: moment().format("DD/MM/YYYY 23:59")
            },
            showSatisfation: false,
            satisfactionId: 0
        }
    }

    updateFilter = (value, name) => {
        if (
            !validateDatesFilter(this.state.filter.from, this.state.filter.to, {
                value: value,
                name: name
            })
        ) {
            toast("A data elexida no é válida", {
                className: "toast-error",
                autoClose: 2000
            });
        } else {
            let filter = {};
            filter[name] = value;
            if(name === 'municipality') filter.office = -1;
            const { defaultLimit } = this.props.main;
            this.setState({ filter: { ...this.state.filter, ...filter }, currentPage: 0 }, () => {
                this.loadData(
                    0,
                    defaultLimit
                );
            });
        }
    };

    componentDidMount() {
        const { currentPage } = this.state;
        const { defaultLimit, sessionData } = this.props.main;
        if (sessionData.municipality){
            this.setState({ filter: { ...this.state.filter,  municipality: sessionData.municipality} }, async ()=>{
                this.loadData(currentPage * defaultLimit, defaultLimit);
            })
        } else{
            this.loadData(currentPage * defaultLimit, defaultLimit);
        }
    }

    refresh = () => {
        const { currentPage, currentLimit } = this.state;
        this.loadData(currentPage * currentLimit, currentLimit);
    }

    loadData = async (start, limit, page) => {
        try {
            const { currentPage, currentLimit } = this.state;
            if (page !== undefined && page !== currentPage)
                this.setState({ currentPage: page });
            if (limit !== undefined && limit !== currentLimit)
                this.setState({ currentLimit: limit });
            let currentFilter = this.state.filter;
            let params = {
                type: 'satisfaction',
                start: start,
                limit: limit,
                filter: currentFilter
            }
            let response = await requestSurveys(this.props.main.sessionData.userName, this.props.main.sessionData.passwd, params);
            this.setState({ satisfactionSurveyList: response.result.data, loading: false, rows: response.result.total });
        } catch (err) {
            this.setState({ loading: false });
            console.error(err);
            toast("Produciuse un erro cargando os datos, intenteo de novo máis tarde", { autoClose: 4000, className: "toast-error" })
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.loading === true) {
            return { loading: false }
        }
        return null;
    }

    openSatisfation = (satisfaction) => {
        this.setState({ showSatisfation: true, satisfactionId: satisfaction.id });
    }

    newSatisfation = () => {
        this.setState({ showSatisfation: true, satisfactionId: 'new' });
    }

    closeDetail = () => {
        this.setState({ showSatisfation: false, satisfactionId: 0 });
    }

    render() {
        const { columns, loading, satisfactionSurveyList, rows, filter: { from, to, office, municipality }, showSatisfation, satisfactionId, currentPage, currentLimit } = this.state;
        const { municipalities, offices, users, sessionData } = this.props.main;

        if (showSatisfation) {
            return (
                <Satisfation id={satisfactionId} refresh={this.refresh} close={this.closeDetail} />
            )
        }

        return (
            <Fragment>
                <Grid item xs={12}>
                    <Card elevation={0} style={{ padding: "0.5em 1em" }}>
                        <Grid container spacing={16}>
                            <Grid item xs={4}>
                                <div style={{ flexDirection: "column" }}>
                                    <DatePickerCustom
                                        label="Dende"
                                        value={from}
                                        format="DD/MM/YYYY"
                                        displayFormat="LL"
                                        setDate={moment => {
                                            this.updateFilter(moment.format("DD/MM/YYYY HH:mm"), "from");
                                        }}
                                    />
                                    <DatePickerCustom
                                        label="Ata"
                                        value={to}
                                        format="DD/MM/YYYY"
                                        displayFormat="LL"
                                        setDate={moment => {
                                            this.updateFilter(moment.format("DD/MM/YYYY HH:mm"), "to");
                                        }}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={4}>
                                <SelectComponent
                                    disabled={!!sessionData.municipality}
                                    label="Concello"
                                    defaultValue="Todos"
                                    items={municipalities}
                                    value={municipality}
                                    fieldValue="id"
                                    fieldName="name"
                                    setValue={event => {
                                        this.updateFilter(event.target.value, "municipality");
                                    }} />
                                <SelectComponent
                                    label="Oficina"
                                    defaultValue="Todas"
                                    items={(!!municipality && municipality != -1) ? offices.filter((office) => { return office.municipality_id === municipality }) : offices}
                                    value={office}
                                    fieldValue="id"
                                    fieldName="name"
                                    setValue={event => {
                                        this.updateFilter(event.target.value, "office");
                                    }}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <Button variant="raised" color="secondary" style={{ float: 'right' }} onClick={this.newSatisfation}><AddIcon />Engadir enquisa de satisfacción</Button>
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>

                {loading ?
                    <Card style={{width: '100%'}}>
                        <Typography variant="headline" component="h4">Cargando enquisas de satisfacción...</Typography>
                        <LinearProgress />
                    </Card>
                    :
                    <PaginatedTable
                        filter={{ municipalities: municipalities, offices: offices, users: users }}
                        openSurvey={this.openSatisfation}
                        updateItems={this.loadData}
                        itemList={satisfactionSurveyList}
                        rows={rows}
                        columns={columns}
                        noResultsText="Non se atoparon enquisas"
                        datefilter={true}
                        defaultPage={currentPage}
                        defaultLimit={currentLimit}
                        />
                }
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    main: state.main
});

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(mainActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Satisfations);



// WEBPACK FOOTER //
// ./src/components/Satisfations/Satisfations.js